var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-avatar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "transparent",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "google-icon",
    transform: "translate(8.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9977805,17.3754561 C32.9977805,15.9778784 32.8854572,14.9580138 32.6423694,13.9003909 L16.8356023,13.9003909 L16.8356023,20.2083698 L26.1138181,20.2083698 C25.9268275,21.7759901 24.9166914,24.136795 22.6719014,25.7231642 L22.6404354,25.9343502 L27.6382429,29.8433754 L27.9844979,29.8782693 C31.1644988,26.9130713 32.9977805,22.5502956 32.9977805,17.3754561",
    id: "Path",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8356023,33.9954859 C21.3811504,33.9954859 25.1971773,32.4845031 27.9844979,29.8782693 L22.6719014,25.7231642 C21.250257,26.7241496 19.3421791,27.4229385 16.8356023,27.4229385 C12.3835495,27.4229385 8.60492071,24.4578707 7.25794357,20.3595332 L7.06050728,20.3764594 L1.86371601,24.4370385 L1.79575459,24.627783 C4.5642472,30.1803356 10.2509539,33.9954859 16.8356023,33.9954859",
    id: "Path",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25794357,20.3595332 C6.90253246,19.3019104 6.6968428,18.1686407 6.6968428,16.9977429 C6.6968428,15.826715 6.90253246,14.6935755 7.23924451,13.6359526 L7.2298305,13.4107049 L1.96791491,9.28489501 L1.79575459,9.36757266 C0.654725032,11.6717401 0,14.2592249 0,16.9977429 C0,19.736261 0.654725032,22.3236156 1.79575459,24.627783 L7.25794357,20.3595332",
    id: "Path",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8356023,6.5724172 C19.9969041,6.5724172 22.1293708,7.95111578 23.3453255,9.10326459 L28.0966923,4.41941316 C25.1786072,1.68089515 21.3811504,0 16.8356023,0 C10.2509539,0 4.5642472,3.81502004 1.79575459,9.36757266 L7.23924451,13.6359526 C8.60492071,9.53761519 12.3835495,6.5724172 16.8356023,6.5724172",
    id: "Path",
    fill: "#EB4335"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAvatar);
export default __webpack_public_path__ + "static/media/google-avatar.39ffd56a9f2fc8eab97925ba14e9fa18.svg";
export { ForwardRef as ReactComponent };